/*******************************************/

import calcFunctions from './gen-content';

// play clicked
export function play() {
  if (this.state.playState === 'pause') {
    this.svg.play();
  } else {
    this.svg.pause();
  }
  this.setState(state => ({
    playState: state.playState === 'pause' ? 'play' : 'pause',
  }));
}

export function createAnimation() {
  // calcFunctions.genContentAnimMethods();
  // this.setState({
  //   content: calcFunctions.createContent[0].createContent(),
  //   anim: calcFunctions.createContent[0].createAnim,
  // });
  this.svg.createAnimation(this.state.anim, this.state.content.pathRefs);
  // if (this.state.exampleIdx === this.hida) {
  setTimeout(play.bind(this), 0);
  // }
}
